import { Component, inject } from '@angular/core';
import { RolesService } from '../services/roles.service';
import { ProfileService } from '../../profile/services/profile.service';
import { RoleFormComponent } from "../role-form/role-form.component";
import { AccessService } from '../../core/services/access.service';

@Component({
  selector: 'app-role-create',
  standalone: true,
  imports: [RoleFormComponent],
  templateUrl: './role-create.component.html',
  styleUrl: './role-create.component.css'
})
export class RoleCreateComponent {
  service = inject(RolesService)
  profile = inject(ProfileService).profile
  access = inject(AccessService).access

  ngOnInit(): void {
    this.service.title.update((value) => 'Nuevo Rol')
  }
}
